import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.WorkflowSettingsPopupContent.SectionUseRejectedPrefix', {
    title: 'Add “REJECTED” prefix to Xero reference',
    subtitle: 'Automatically add the “REJECTED” prefix to the Xero Reference when a request is rejected in ApprovalMax',
    optionYes: 'Yes, add the prefix',
    optionNo: 'No, do not add the prefix',
});
